import { useFormikContext } from "formik";
import React from "react";
import { Accordion } from "react-bootstrap";

import { IFormITR1 } from "../../../config/interfaces";
import PriceDisplay from "../../PriceDisplay";
import SvgImage from "../../SvgImage";
import { ContextAwareToggle } from "../../accordion";

type Props = {};

const ReviewTaxPayableDetails: React.FC<Props> = (props: Props) => {
  const { values } = useFormikContext<IFormITR1>();

  return (
    <>
      <Accordion.Item eventKey="review-file-3">
        <Accordion.Header>
          <div className="btn-content">
            <SvgImage imgId="salary-information" />
            <h4 className="mb-0">Net Taxable Income</h4>
          </div>
        </Accordion.Header>
        <Accordion.Body>
          <hr />
          <section className="mb-3">
            <dl className="eds-list eds-dl eds-inline-between">
              <div className="eds-list--item">
                <dt>Net Taxable Income (Gross Total Income - Total Deductions)</dt>
                <dd>
                  <PriceDisplay price={values.TotalTaxableIncome} />
                </dd>
              </div>
            </dl>
          </section>
          <Accordion className="accordion-sm">
            <Accordion.Item eventKey="tax-1">
              <ContextAwareToggle eventKey="tax-1" isChild={true}>
                <div className="btn-content justify-content-between">
                  <p className="leading-para fw-bold mb-0">Tax Details</p>
                  <p className="leading-para fw-bold mb-0">
                    <PriceDisplay price={values.ITR1_TaxComputation.NetTaxLiability} />
                  </p>
                </div>
              </ContextAwareToggle>
              <Accordion.Body>
                <section>
                  <dl className="eds-list eds-dl eds-inline-between">
                    <RenderListItem
                      title="Income Tax at normal rates"
                      total={values.ITR1_TaxComputation.TaxPayableOnRebate}
                    />

                    {values.ITR1_TaxComputation.Surcharge ? (
                      <RenderListItem
                        title="Surcharge"
                        total={values.ITR1_TaxComputation.Surcharge}
                      />
                    ) : null}

                    {values.ITR1_TaxComputation.Rebate87A ? (
                      <RenderListItem
                        title="Rebate u/s 87A"
                        total={values.ITR1_TaxComputation.Rebate87A}
                      />
                    ) : null}

                    {values.ITR1_TaxComputation.Rebate87A ? (
                      <RenderListItem
                        title="Tax after Rebate"
                        total={values.ITR1_TaxComputation.TaxPayableOnRebate}
                      />
                    ) : null}

                    {values.TotalSplRateTax ? (
                      <RenderListItem
                        title="Income tax at special rates"
                        total={values.TotalSplRateTax}
                      />
                    ) : null}

                    <RenderListItem
                      title="Health and Education Cess"
                      total={values.ITR1_TaxComputation.EducationCess}
                    />
                    <div className="eds-list--item eds-list--item-subtotal">
                      <dt>Total Tax:</dt>
                      <dd>
                        <PriceDisplay price={values.ITR1_TaxComputation.NetTaxLiability} />
                      </dd>
                    </div>
                  </dl>
                </section>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="tax-2">
              <ContextAwareToggle eventKey="tax-2" isChild={true}>
                <div className="btn-content justify-content-between">
                  <p className="leading-para fw-bold mb-0">Interest Details</p>
                  <p className="leading-para fw-bold mb-0">
                    <PriceDisplay price={values.ITR1_TaxComputation.TotalIntrstPay} />
                  </p>
                </div>
              </ContextAwareToggle>
              <Accordion.Body>
                <section>
                  <dl className="eds-list eds-dl eds-inline-between">
                    {values.ITR1_TaxComputation.IntrstPay.IntrstPayUs234A ? (
                      <RenderListItem
                        title="Interest u/s 234A"
                        total={values.ITR1_TaxComputation.IntrstPay.IntrstPayUs234A}
                      />
                    ) : null}

                    {values.ITR1_TaxComputation.IntrstPay.IntrstPayUs234B ? (
                      <RenderListItem
                        title="Interest u/s 234B"
                        total={values.ITR1_TaxComputation.IntrstPay.IntrstPayUs234B}
                      />
                    ) : null}

                    {values.ITR1_TaxComputation.IntrstPay.IntrstPayUs234C ? (
                      <RenderListItem
                        title="Interest u/s 234C"
                        total={values.ITR1_TaxComputation.IntrstPay.IntrstPayUs234C}
                      />
                    ) : null}

                    {values.ITR1_TaxComputation.IntrstPay.LateFilingFee234F ? (
                      <RenderListItem
                        title="Fees for late filing of return u/s 234F"
                        total={values.ITR1_TaxComputation.IntrstPay.LateFilingFee234F}
                      />
                    ) : null}

                    <div className="eds-list--item eds-list--item-subtotal">
                      <dt>Total Interest Due:</dt>
                      <dd>
                        <PriceDisplay price={values.ITR1_TaxComputation.TotalIntrstPay} />
                      </dd>
                    </div>
                  </dl>
                </section>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <section>
            <dl className="eds-list eds-dl eds-inline-between">
              <div className="eds-list--item eds-list--item-total">
                <dt>Total Tax Payable (Total Tax + Total Interest Due)</dt>
                <dd>
                  <PriceDisplay price={values.ITR1_TaxComputation.TotTaxPlusIntrstPay} />
                </dd>
              </div>
            </dl>
          </section>
        </Accordion.Body>
      </Accordion.Item>
    </>
  );
};

export default ReviewTaxPayableDetails;

const RenderListItem = ({ total, title }: { total: number; title: string }) => {
  return (
    <div className="eds-list--item">
      <dt>{title}</dt>
      <dd>
        <PriceDisplay price={total} />
      </dd>
    </div>
  );
};
